import type { StepProps } from '../AdminSignUpPage';

export interface WelcomeStepProps extends StepProps {
  /** EPN-35 Partner Sign Up override — default matches Admin Sign Up's own approved copy exactly. */
  bodyCopy?: string;
}

/** Success — matches the approved HTML: no auto-login (Admin Sign Up Decision 1's correction — this
 * flow never issues an ordinary application session), just a link to the existing Sign In page. This is a
 * success STATE, not a numbered wizard step — see AdminSignUpPage's left-panel stepper, which shows all 4
 * primary steps as done and none active once this screen is reached. */
export function WelcomeStep({
  bodyCopy = 'Your admin account has been successfully created. Head over to the sign-in page and log in with your credentials to start managing your payroll.',
}: WelcomeStepProps) {
  return (
    <div className="screen active welcome" data-testid="welcome-step">
      <div className="welcome-icon" aria-hidden="true">
        🎉
      </div>
      <h2>
        Welcome to <span className="brand-esco">Esco</span>
        <span className="brand-chex">chex!</span>
      </h2>
      <p>{bodyCopy}</p>
      <a href="/">
        <button className="signin-btn" type="button">
          Sign In
        </button>
      </a>
    </div>
  );
}
